import angular from 'angular';
import moment from 'angular-moment';
import DateUtil from "../../../../components/logic/date_util/date_util.module";
import PowerFormatter from "../../../../components/logic/power-formatter/power-formatter.logic";
import MonthlyMaxDemandPowerService from '../../../../components/api/monthly_max_demand_power/monthly_max_demand_power.service';

import chartConfig from './compare-graph-yearly.config';

export class CompareGraphYearlyDemand {
  /*@ngInject*/
  constructor($filter, $scope, $q, moment, DateUtil, PowerFormatter, MonthlyMaxDemandPowerService) {
    this.$filter = $filter;
    this.DateUtil = DateUtil;
    this.moment = moment;
    this.$q = $q;
    this.PowerFormatter = PowerFormatter;
    this.MonthlyMaxDemandPowerService = MonthlyMaxDemandPowerService;

    this.chartConfig = chartConfig(this);

    $scope.$watch('$ctrl.selectedConfigs', () => this.createGraph());
  }

  $onInit() {}

  createGraph() {
    this.endDate = this.moment().startOf('month');
    this.startDate = this.endDate.clone().subtract(12, 'months');

    if (this.chart) {
      this.chart.reflow();
    }
    if (this.selectedConfigs.length === 0) {
      return;
    }
    this.resetSeries();

    this.categories = [];
    const start = this.startDate.clone().add(this.startDate.utcOffset(), 'minutes').utc();
    for (let i = 0; i < 13; i++) {
      this.categories.push(start.valueOf());
      start.add(1, 'month');
    }

    const promises = [];
    for (let config of this.selectedConfigs) {
      promises.push(this.getDemandData(config));
    }

    this.$q.all(promises).then(results => {
      for (let result of results) {
        this.addSeries(result.demandPowers, result.config);
      }
      this.chart.redraw();
      this.chart.reflow();
    });
  }

  getDemandData(config) {
    return new Promise(resolve => {
      this.MonthlyMaxDemandPowerService.showYearly({id: config.id}, res => {
        const powers = res.powers;

        const demandPowerObjects = this.PowerFormatter.formatMonthlyDemandPowers(powers, this.categories);
        const demandPowers = demandPowerObjects.map(power => {return power.y});
        resolve({demandPowers, config});
      });
    });
  }

  addSeries(powers, config) {
    if (!powers) {
      return;
    }
    const graphData = this.categories.map((e, i) => {
      return [e, powers[i]];
    });
    this.chart.addSeries({
      name: config.pms_service_code,
      type: this.graphType,
      data: graphData
    });
  }

  resetSeries() {
    if (!this.chart) {
      return;
    }
    while (this.chart.series.length > 0) {
      this.chart.series[0].remove(false);
    }
  }
}

export default angular.module('leptonApp.compareGraphYearlyDemand', [moment, DateUtil, PowerFormatter, MonthlyMaxDemandPowerService])
  .component('compareGraphYearlyDemand', {
    template: require('./compare-graph-yearly.html'),
    controller: CompareGraphYearlyDemand,
    bindings: {
      selectedConfigs: '=',
      configIds: '=',
      graphType: '='
    }
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/compare-graph/demand/yearly/compare-graph-yearly.component.js